<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="card-header mt-4">
      <h1>Edit Editor</h1>
      <hr />
      <form action="#">
        <div class="row">
          <div class="col-md-12 text-center mb-4" id="file-input">
            <label>
              <input type="file" @change="setImage" />
              <img
                class="avatar avatar-lg rounded-circle"
                id="profile-picture"
                :src="cropImg ? cropImg : require('@/assets/default_profile_picture.png')"
                alt
              />
            </label>

            <modal :show.sync="showModal">
              <div class="mt-4 mb-4">
                <vue-cropper
                  ref="cropper"
                  :guides="true"
                  :view-mode="2"
                  drag-mode="crop"
                  :auto-crop-area="0.5"
                  :min-container-width="250"
                  :min-container-height="180"
                  :background="true"
                  :rotatable="true"
                  :src="imgSrc"
                  alt="Source Image"
                  :img-style="{ 'width': '400px', 'height': '300px' }"
                ></vue-cropper>
                <base-button
                  outline
                  type="primary"
                  class="mt-6"
                  @click="cropImage"
                >Crop Profile Picture</base-button>
              </div>
            </modal>
          </div>
          <!-- First Name -->
          <div class="col-md-12">
            <label for="Fist Name">First Name</label>
            <span class="error" v-if="!firstName && !isInputValid">* field required</span>
            <base-input alternative placeholder="First Name" v-model="firstName" />
          </div>
          <!--  -->
          <!-- Last Name -->
          <div class="col-md-12">
            <label for="Last Name">Last Name</label>
            <span class="error" v-if="!lastName && !isInputValid">* field required</span>
            <base-input alternative placeholder="Last Name" v-model="lastName" />
          </div>
          <!--  -->

          <!-- Email -->
          <div class="col-md-12">
            <label for="Email">Email</label>
            <span class="error" v-if="!email && !isInputValid">* field required</span>
            <base-input alternative placeholder="Email" v-model="email" />
          </div>
          <!--  -->

          <!-- Phone Number -->
          <div class="col-md-12">
            <label for="Phone Number">Phone Number</label>
            <span class="error" v-if="!phone && !isInputValid">* field required</span>
            <base-input alternative placeholder="Phone Number" v-model="phone" />
          </div>

          <div class="col-md-12 text-center mt-6">
            <base-button type="primary" :disabled="isLoading" @click="onSubmit()">Update User</base-button>
          </div>
          <div class="col-md-12 text-center mt-5 mb-4" v-if="error">
            <span class="response-error">* {{ error.message }}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import store from '@/store'

import { mapState } from 'vuex'
import { GET_USER, UPLOAD_FILE, UPDATE_USER } from '@/store/actions.type'

import { isEmail } from '@/common/utils'

const MAX_IMAGE_FILE_SIZE = 500 * 1000

export default {
  components: { VueCropper },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      borderRadius: 200,
      imgSrc: require('@/assets/default_profile_picture.png'),
      cropImg: null,
      showModal: false,
      isInputValid: true
    }
  },
  created() {
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.email = this.user.email
    this.phone = this.user.phone
    this.cropImg = this.user.profile
  },
  destroyed() {
    this.$store.state.user.error = null
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(GET_USER, to.params.id).then(() => next())
  },
  methods: {
    setImage(e) {
      this.$emit('input', e.target.files[0])
      const file = e.target.files[0]
      if (!file.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (file.size >= MAX_IMAGE_FILE_SIZE) {
        alert('Please select a smaller image size')
        return
      }
      if (typeof FileReader === 'function') {
        this.showModal = true
        const reader = new FileReader()
        reader.onload = event => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const file = this.dataURLtoFile(this.cropImg, this.fileName)
      this.$store
        .dispatch(UPLOAD_FILE, { file, imageType: 'uploads' })
        .then(() => {
          this.showModal = false
        })
    },
    onSubmit() {
      if (this.firstName && this.lastName && this.email && this.phone) {
        if (!isEmail(this.email)) {
          this.$store.state.user.error = {
            message: 'Invalid Email Address !'
          }
          return
        }
        var url = this.profileUrl
        console.log('url: ' + url)
        if (!url) {
          url = this.user.profile
        }

        this.$store
          .dispatch(UPDATE_USER, {
            id: this.user.id,
            user: {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              phone: this.phone,
              country: this.user.country,
              profile: url,
              role: 'content_editor'
            }
          })
          .then(() => {
            this.$router.push({ name: 'user_management' })
          })
      } else {
        this.isInputValid = false
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.editor,
      profileUrl: state => state.file.fileUrl,
      isLoading: state => state.user.isLoading,
      error: state => state.user.error
    })
  }
}
</script>

<style scoped>
.btn-dropdown {
  border: 1px solid #cad1d7 !important;
  margin-right: 10px !important;
}
.btn-dropdown:hover {
  background-color: transparent !important;
  color: #32325d !important;
}
.btn-dropdown:focus {
  background-color: transparent !important;
  color: #32325d !important;
}
.full-width {
  width: 100% !important;
}
.dropdown-item {
  cursor: default;
}
.custom-control-label::before {
  left: -2rem !important;
  top: 0 !important;
}
.custom-control-label::after {
  left: -2rem !important;
  top: 0 !important;
}
.custom-control {
  display: inline-flex;
}
.nav-fill .nav-item {
  flex: 0 0 auto !important;
}
.flag {
  margin-right: 5px !important;
}
#file-input {
  display: inline-block !important;
}
#file-input input[type='file'] {
  display: none !important;
}
#profile-picture {
  cursor: pointer;
}
.avatar-lg {
  width: 100px !important;
  height: 100px !important;
}

.inline-flex {
  display: inline-flex;
}
</style>
